module.exports = __webpack_public_path__ + "img/top-bar.ff6da8fb.png";